import {ILccaActivityImperial, ILccaAlternativeImperial} from '@/modules/lcca/interfaces/lccaCalculated';

export enum BaseProbVariables {
  annualGrowthTraffic = 'annualGrowthTraffic',
  passengerCarsTime = 'passengerCarsTime',
  singleUnitTrucksTime = 'singleUnitTrucksTime',
  combinationTrucksTime = 'combinationTrucksTime',

}


export interface IAlternativeResult {
  alternative: ILccaAlternativeImperial,
  activityResults: IActivityResultBreakdown[],
  activityOptions: any,
  agencyCosts: number,
  userCosts: number,
  delayCosts: number,
  vehicleCosts: number,
  vehicleCostsByType: {
    cars: number,
    trucks: number,
    comboTrucks: number
  },
  queueLengthWarning: boolean

  monteCarloSortedCosts: number[] | null,
  monteCarloProcessedData: IMonteCarloProcessedData | null
}

export interface IActivityResults {
  alternative: ILccaAlternativeImperial,
  agencyCosts: number,
  // agencyCosts: lccaResults.agencyCost_r[index].map(function (element) { return isNaN(element) ? 0 : element; }),
  // activities: alternative.activities, //redundant - alternative.activities is already in alternative
  userCosts: number,
  // userDiscountedCosts: userDiscountedResults,
  delayCosts: number,
  vehicleCosts: number,
  resultBreakdown: IActivityResultBreakdown,
  queueLengthWarning: boolean
}

export interface IActivityResultBreakdown {
  name: string | null,
  activity: ILccaActivityImperial | null,
  result: IUserCostResults | null,
  totalCosts: {
    cars: number,
    trucks: number,
    comboTrucks: number
  }
}

export interface IMonteCarloProcessedData {
  data: number[],
  bins: number[][],
  lower: number,
  upper: number,
  mode: any, // Output of d3.histogram()[index] operation
  median: number,
  mean: number,
  stDev: number,
}

export interface IUserCostResults {
  queueLengthWarning: boolean,
  delayCostsPerDay: number,
  vehicleCostsTotal: number,
  vehicleCostsPerDay: number,
  delayCostsTotal: number,
  queuePeriods: IQueuePeriod[],
  traverseWzCosts: {
    cars: number,
    trucks: number,
    comboTrucks: number,
    total: number,
  },
  weightedSlowCosts: {
    delay: {
      cars: number,
      trucks: number,
      comboTrucks: number,
      total: number,
    },
    vehicle: {
      cars: number,
      trucks: number,
      comboTrucks: number,
      total: number,
    }
  },
  weightedStoppedCosts: {
    delay: {
      cars: number,
      trucks: number,
      comboTrucks: number,
      total: number,
    },
    vehicle: {
      cars: number,
      trucks: number,
      comboTrucks: number,
      total: number,
    }
  },
  totalCostsPerDay: {
    cars: number,
    trucks: number,
    comboTrucks: number,
    total: number
  },
  totalCosts: {
    cars: number,
    trucks: number,
    comboTrucks: number,
    total: number
  },
  discountedCosts: {
    cars: number,
    trucks: number,
    comboTrucks: number,
    total: number
  }
}

export interface IQueuePeriod {
  totalCount: number,
  count: number,
  queueLength: number,
  queueSpeed: number,
  upstreamSpeed: number,
  groups: number

  avgQueuedVehicles: number,
  avgQueueLength: number,
  avgQueueSpeed: number,
  avgUpstreamSpeed: number,
  avgDelayPerVehicle: number,
  delays: {
    cars: number,
    trucks: number,
    comboTrucks: number,
    total: number,
  },
  idleVocCost: {
    cars: number,
    trucks: number,
    comboTrucks: number,
    total: number,
  },
  idleDelayCost: {
    cars: number,
    trucks: number,
    comboTrucks: number,
    total: number,
  }
}
